// 旧书页上随机浮现的诗句（拾取时给玩家一点"念出来"的实感）
export const POEM_LINES = [
  '「海内存知己，天涯若比邻。」',
  '「会当凌绝顶，一览众山小。」',
  '「大漠孤烟直，长河落日圆。」',
  '「我寄愁心与明月，随风直到夜郎西。」',
  '「春风又绿江南岸，明月何时照我还。」',
  '「沉舟侧畔千帆过，病树前头万木春。」',
  '「但愿人长久，千里共婵娟。」',
];

// 造句/对句谜题：用收集到的字填回空缺，复原诗句
// lines 用 '_' 标记空格；answer 与空格顺序一一对应；decoys 为干扰（多为烂梗）
export const PUZZLES = {
  guanju: {
    title: '复原《关雎》',
    intro: '挡路的绿雾里翻涌着烂梗。把记忆里的诗句补全，让它散去。',
    lines: ['关关雎鸠，在河之_。', '窈窕淑女，君子好_。'],
    answer: ['洲', '逑'],
    decoys: ['绝绝子', 'YYDS', '岛', '丘', '6'],
    solveText: '诗句完整的瞬间，绿雾像被一阵清风吹散。',
  },
  tengwang: {
    title: '复原《滕王阁序》·《正气歌》',
    intro: '算法的蓝墙在前。两句古文若能补全，浩然之气可破之。',
    lines: ['落霞与孤_齐飞，秋水共长_一色。', '天地有正_，杂然赋流_。'],
    answer: ['鹜', '天', '气', '形'],
    decoys: ['栓Q', '泰裤辣', '雁', '地', '神', '色'],
    solveText: '四个字归位，蓝墙裂开一道缝——那是被压住的"正气"。',
  },
  voidverse: {
    title: '在虚无里点一句诗',
    intro: '通往深渊的门吞掉一切声音。只有一句完整的诗，能在黑暗里点出路。',
    lines: ['春_不觉晓，处_闻啼鸟。', '夜来_雨声，花落知多_。'],
    answer: ['眠', '处', '风', '少'],
    decoys: ['emo', '破防', '睡', '时', '雨', '花'],
    solveText: '最后一个字落下，黑暗里亮起一串字形铺成的小径。',
  },
  // 体育馆诗屏解谜：解开后削弱 BOSS 防御
  zhengqi: {
    title: '点亮诗屏 · 春晓',
    intro: '一块熄灭的诗屏，等你用《春晓》的句子重新点亮。诗意能削弱茧房的算法屏障。',
    lines: ['春_不觉晓，处_闻啼鸟。', '夜来_雨声，花落知多_。'],
    answer: ['眠', '处', '风', '少'],
    decoys: ['YYDS', '绝绝子', '睡', '时', '雨', '花'],
    solveText: '诗句归位，诗屏亮起金光——茧房的推荐屏障出现裂痕，核心变得更脆了！',
  },
  // —— 支线：唤醒失语者 ——
  cure_jingye: {
    title: '唤醒 · 念给他听',
    intro: '他死死盯着你，嘴里只剩一个音。也许一句最简单的诗，能照进去。',
    lines: ['床前明月_，疑是地上霜。', '举头望明_，低头思故乡。'],
    answer: ['光', '月'],
    decoys: ['YYDS', '绝绝子', '水', '日'],
    solveText: '他的眼睛慢慢聚焦了。"……月光。原来是月光啊。"',
  },
  cure_dengguan: {
    title: '唤醒 · 登高的人',
    intro: '她蜷在墙角，反复念着同一个字。给她接上整句吧。',
    lines: ['_日依山尽，黄河入海流。', '欲穷千_目，更上一层楼。'],
    answer: ['白', '里'],
    decoys: ['泰裤辣', '破防', '红', '重'],
    solveText: '她忽然落泪："白日……我以前，是会背的。"',
  },
  // —— 第五章：新诗词谜题 ——
  jiangjinjiu: {
    title: '复原《将进酒》',
    intro: '方知远的终端上，一首诗的残缺投影在闪烁。补全它，才能打开记忆碎片的封印。',
    lines: ['君不见黄_之水天上来，', '奔流到_不复回。'],
    answer: ['河', '海'],
    decoys: ['YYDS', '绝绝子', '云', '雨'],
    solveText:
      '诗句完整的瞬间，终端屏幕"鼓"了起来——从一块扁平的面板，变成了有弧度的、真正的屏幕。一段记忆从中流出。',
  },
  chunwang: {
    title: '复原《春望》',
    intro: '守卷人的记忆碎片在数据流中漂浮。补全这首诗，帮他找回自己的语言。',
    lines: ['国破_河在，', '城_草木深。'],
    answer: ['山', '春'],
    decoys: ['YYDS', '6', '河', '城'],
    solveText:
      '诗句完整的瞬间，守卷人的轮廓"鼓"了起来——从一个模糊的代码残影，变成了一个有立体感的人形。他笑了。',
  },
  yueye: {
    title: '复原《月夜忆舍弟》',
    intro: '最后的封印。一首关于月亮的诗——月亮的阴晴圆缺，就是"另一面"最好的隐喻。',
    lines: ['今夜_明人尽望，', '不知_思落谁家。'],
    answer: ['月', '秋'],
    decoys: ['YYDS', '绝绝子', '春', '夜'],
    solveText: '最后一个字落下，黑暗中亮起一串字形铺成的小径。小径的尽头，最后一片记忆碎片在发光。',
  },
  // —— 失语者村落：额外诗词 ——
  cure_cangsang: {
    title: '唤醒 · 沧桑的老兵',
    intro: '他握着一根看不见的剑，嘴里断断续续念着半句词。',
    lines: ['醉_挑灯看剑，', '梦回吹角连_。'],
    answer: ['里', '营'],
    decoys: ['破防', '栓Q', '中', '队'],
    solveText: '他睁开眼，目光忽然变得锐利："我以前是当兵的。这首词……是老长官教我的。"',
  },
  cure_chuncan: {
    title: '唤醒 · 蚕与烛',
    intro: '她的手指在膝上不停地画着什么，嘴里只有一两个字。',
    lines: ['春_到死丝方尽，', '蜡_成灰泪始干。'],
    answer: ['蚕', '炬'],
    decoys: ['YYDS', '6', '花', '火'],
    solveText: '她缓缓抬头，眼眶泛红："我教了一辈子书。原来……我还能教。"',
  },
  cure_e: {
    title: '唤醒 · 鹅',
    intro: '一个孩子蜷在角落，嘴里反复念着一个音。',
    lines: ['鹅鹅鹅，', '曲项向_歌。'],
    answer: ['天'],
    decoys: ['YYDS', '6', '水', '地'],
    solveText: '孩子笑了："我妈妈以前……天天给我念这首。"',
  },
};
